// Kit steps: like kit-builder.v2.js, but each step offers several products.
// The customer picks one product per step, then that product's options.
(function () {
  "use strict";

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var value = (Math.round(cents) / 100).toFixed(2);
    var withComma = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (!format) return "$" + withComma;
    if (format.indexOf("{{amount}}") !== -1) return format.replace("{{amount}}", withComma);
    if (format.indexOf("{{amount_no_decimals}}") !== -1) {
      return format.replace("{{amount_no_decimals}}", String(Math.round(cents / 100)));
    }
    if (format.indexOf("{{amount_with_comma_separator}}") !== -1) {
      return format.replace("{{amount_with_comma_separator}}", value.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."));
    }
    return format.replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  // A discount comes off the compare-at price (the price when there is none)
  // and never lands above the item's own price. No discount: the item's price.
  function linePrices(v, pct) {
    var price = v.price;
    var cmp = v.compareAtPrice > price ? v.compareAtPrice : price;
    var sale = pct > 0 ? Math.min(price, Math.round(cmp * (100 - pct) / 100)) : price;
    return { sale: sale, cmp: cmp, price: price };
  }

  // A saving shows the original price crossed out and the new price green
  // (.is-sale); no saving shows the price alone, in black.
  function showPrice(saleEl, cmpEl, pctEl, sale, cmp, format) {
    var saved = savedPercent(sale, cmp);
    if (saleEl) {
      saleEl.textContent = formatMoney(sale, format);
      saleEl.classList.toggle("is-sale", saved > 0);
    }
    if (cmpEl) cmpEl.textContent = saved ? formatMoney(cmp, format) : "";
    if (pctEl) {
      pctEl.hidden = !saved;
      pctEl.textContent = saved ? ("-" + saved + "%") : "";
    }
  }

  function savedPercent(sale, cmp) {
    return cmp > sale ? Math.round((cmp - sale) / cmp * 100) : 0;
  }

  function isTitleOnly(opt) {
    return opt && opt.name === "Title" && (opt.values || []).length <= 1;
  }

  function findVariant(item, selected) {
    var variants = item.variants || [];
    return variants.find(function (v) {
      return (item.options || []).every(function (opt, i) {
        if (isTitleOnly(opt)) return true;
        var wanted = selected[opt.name];
        if (!wanted) return true;
        return v.options[i] === wanted;
      });
    }) || null;
  }

  function firstAvailableVariant(item) {
    var variants = item.variants || [];
    return variants.find(function (v) { return v.available; }) || variants[0] || null;
  }

  function firstAvailableChoice(step) {
    var index = (step.choices || []).findIndex(function (item) {
      return (item.variants || []).some(function (v) { return v.available; });
    });
    return index === -1 ? 0 : index;
  }

  function optionImage(item, optName, value) {
    var idx = item.options.findIndex(function (o) { return o.name === optName; });
    if (idx === -1) return "";
    var v = item.variants.find(function (vr) { return vr.options[idx] === value && vr.image; });
    return v ? v.image : (item.featuredImage || "");
  }

  function valueIsAvailable(item, optName, value, selected) {
    var idx = (item.options || []).findIndex(function (o) { return o.name === optName; });
    if (idx === -1) return false;
    return (item.variants || []).some(function (v) {
      if (!v.available) return false;
      if (v.options[idx] !== value) return false;
      return (item.options || []).every(function (opt, i) {
        if (i === idx || isTitleOnly(opt)) return true;
        var wanted = selected[opt.name];
        if (!wanted) return true;
        return v.options[i] === wanted;
      });
    });
  }

  // In stock in at least one combination, whatever else is selected
  function valueInStock(item, optName, value) {
    var idx = (item.options || []).findIndex(function (o) { return o.name === optName; });
    if (idx === -1) return false;
    return (item.variants || []).some(function (v) { return v.available && v.options[idx] === value; });
  }

  // Available variant with this value that changes the other picks least,
  // preferring the nearest value (e.g. the next size up or down)
  function closestVariant(item, optName, value, selected) {
    var options = item.options || [];
    var idx = options.findIndex(function (o) { return o.name === optName; });
    var best = null;
    var bestScore = Infinity;
    (item.variants || []).forEach(function (v) {
      if (!v.available || v.options[idx] !== value) return;
      var score = 0;
      options.forEach(function (opt, i) {
        if (i === idx || isTitleOnly(opt)) return;
        var wanted = selected[opt.name];
        if (!wanted || v.options[i] === wanted) return;
        var values = opt.values || [];
        score += 1 + Math.abs(values.indexOf(v.options[i]) - values.indexOf(wanted)) / 100;
      });
      if (score < bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  // Pick a value. If that combination isn't in stock, move the other
  // options to the closest one that is, so every in-stock value is one click away.
  function selectValue(item, selected, optName, value) {
    selected[optName] = value;
    var current = findVariant(item, selected);
    if (current && current.available) return;
    var v = closestVariant(item, optName, value, selected);
    if (!v) return;
    (item.options || []).forEach(function (opt, i) {
      if (!isTitleOnly(opt)) selected[opt.name] = v.options[i];
    });
  }

  // e.g. "blue / 7m" for the picks other than optName
  function otherPicks(item, selected, optName) {
    return (item.options || []).filter(function (opt) {
      return opt.name !== optName && !isTitleOnly(opt) && selected[opt.name];
    }).map(function (opt) { return selected[opt.name]; }).join(" / ");
  }

  function KitSteps(root) {
    this.root = root;
    var jsonEl = qs(root, "[data-kit-steps-json]");
    if (!jsonEl) return;
    try { this.data = JSON.parse(jsonEl.textContent); }
    catch (e) { return; }
    this.steps = this.data.steps || [];
    this.packageDiscount = this.data.packageDiscount;
    this.moneyFormat = this.data.moneyFormat || "${{amount}}";
    // Chosen product per step, and option picks per step + product so
    // switching products and back keeps the earlier picks.
    this.choice = [];
    this.selected = {};
    this.steps.forEach(function (step, index) {
      this.choice[index] = firstAvailableChoice(step);
      this.ensureSelection(index);
    }, this);
    this.bind();
    // Steps render open, so fill each panel's choices and options straight away
    this.steps.forEach(function (step, index) {
      this.renderChoicePrices(index);
      this.renderPanel(index);
    }, this);
    this.syncAll();
  }

  // The step's own Discount %, else the package's Kit Discount, else none.
  KitSteps.prototype.stepDiscount = function (index) {
    var step = this.steps[index];
    if (step && step.discount != null) return Number(step.discount) || 0;
    if (this.packageDiscount != null) return Number(this.packageDiscount) || 0;
    return 0;
  };

  // Each choice tile shows its lowest kit price over available variants.
  KitSteps.prototype.renderChoicePrices = function (index) {
    var card = this.cardForIndex(index);
    var step = this.steps[index];
    if (!card || !step) return;
    var pct = this.stepDiscount(index);
    var self = this;
    qsa(card, "[data-kit-choice]").forEach(function (btn) {
      var item = (step.choices || [])[Number(btn.getAttribute("data-kit-choice"))];
      var el = qs(btn, "[data-kit-choice-price]");
      if (!item || !el) return;
      var sales = (item.variants || []).filter(function (v) { return v.available; }).map(function (v) {
        return linePrices(v, pct).sale;
      });
      if (!sales.length) return;
      var min = Math.min.apply(null, sales);
      var varies = sales.some(function (s) { return s !== min; });
      el.textContent = (varies ? "From " : "") + formatMoney(min, self.moneyFormat);
    });
  };

  KitSteps.prototype.item = function (index) {
    var step = this.steps[index];
    return step ? (step.choices || [])[this.choice[index]] || null : null;
  };

  KitSteps.prototype.selection = function (index) {
    var item = this.item(index);
    if (!item) return {};
    var key = index + ":" + item.id;
    if (!this.selected[key]) this.selected[key] = {};
    return this.selected[key];
  };

  KitSteps.prototype.ensureSelection = function (index) {
    var item = this.item(index);
    if (!item) return;
    var sel = this.selection(index);
    var needs = (item.options || []).some(function (opt) {
      if (isTitleOnly(opt)) return false;
      return !sel[opt.name];
    });
    if (!needs) {
      var current = findVariant(item, sel);
      if (current && current.available) return;
    }
    var v = firstAvailableVariant(item);
    if (!v) return;
    (item.options || []).forEach(function (opt, i) {
      if (isTitleOnly(opt)) return;
      if (v.options[i] != null) sel[opt.name] = v.options[i];
    });
  };

  KitSteps.prototype.cardForIndex = function (index) {
    return qs(this.root, '[data-kit-card][data-kit-index="' + index + '"]');
  };

  KitSteps.prototype.bind = function () {
    var self = this;
    qsa(this.root, "[data-kit-card]").forEach(function (card) {
      var index = Number(card.getAttribute("data-kit-index"));
      qsa(card, "[data-kit-choice]").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          if (btn.disabled) return;
          self.choose(index, Number(btn.getAttribute("data-kit-choice")));
        });
      });
    });
    var form = qs(this.root, "[data-kit-form]");
    if (form) form.addEventListener("submit", function (e) { self.submit(e); });
  };

  KitSteps.prototype.choose = function (index, choiceIndex) {
    this.choice[index] = choiceIndex;
    this.ensureSelection(index);
    var item = this.item(index);
    if (item) this.showInGallery(item);
    this.renderPanel(index);
    this.syncAll();
  };

  // Show the chosen product's featured image in the product gallery.
  // Clicking its thumbnail drives both the desktop viewer and the mobile slider.
  KitSteps.prototype.showInGallery = function (item) {
    var product = this.root.closest(".product--outer");
    if (!product || !item.featuredMediaId) return;
    var thumb = qs(product, '[data-gallery-thumbnail][data-media="' + item.featuredMediaId + '"]');
    if (thumb) thumb.click();
  };

  KitSteps.prototype.currentVariant = function (index) {
    var item = this.item(index);
    if (!item) return null;
    return findVariant(item, this.selection(index));
  };

  KitSteps.prototype.isConfigured = function (index) {
    var item = this.item(index);
    if (!item) return false;
    var sel = this.selection(index);
    return (item.options || []).every(function (opt) {
      if (isTitleOnly(opt)) return true;
      if (!(opt.values || []).length) return true;
      return !!sel[opt.name];
    });
  };

  KitSteps.prototype.renderPanel = function (index) {
    var item = this.item(index);
    var card = this.cardForIndex(index);
    if (!item || !card) return;
    var current = this.choice[index];
    qsa(card, "[data-kit-choice]").forEach(function (btn) {
      btn.classList.toggle("is-selected", Number(btn.getAttribute("data-kit-choice")) === current);
    });
    var variant = this.currentVariant(index);
    var prices = linePrices(variant || item, this.stepDiscount(index));
    showPrice(qs(card, "[data-panel-sale]"), qs(card, "[data-panel-compare]"), qs(card, "[data-panel-pct]"), prices.sale, prices.cmp, this.moneyFormat);
    this.renderOptions(index, card);
  };

  KitSteps.prototype.renderOptions = function (index, card) {
    var mount = qs(card, "[data-kit-options]");
    if (!mount) return;
    mount.innerHTML = "";
    var self = this;
    var item = this.item(index);
    var sel = this.selection(index);
    var meaningful = (item.options || []).filter(function (opt) {
      return opt.values && opt.values.length && !isTitleOnly(opt);
    });
    if (!meaningful.length) {
      mount.innerHTML = '<p class="kit-builder__item-sub">No size options — this item is ready.</p>';
      return;
    }
    meaningful.forEach(function (opt) {
      var wrap = document.createElement("div");
      wrap.className = "kit-builder__opt";
      var label = document.createElement("p");
      label.className = "kit-builder__opt-label";
      var current = sel[opt.name] || "";
      label.textContent = "Select " + opt.name + (current ? ("  " + current) : "");
      if (opt.sizeChart) {
        var a = document.createElement("a");
        a.className = "kit-builder__size-chart";
        a.href = opt.sizeChart;
        a.target = "_blank";
        a.rel = "noopener";
        a.textContent = "Size chart";
        label.appendChild(a);
      }
      wrap.appendChild(label);
      var isColor = /colou?r/i.test(opt.name);
      var box = document.createElement("div");
      box.className = isColor ? "kit-builder__swatches" : "kit-builder__pills";
      opt.values.forEach(function (val) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = isColor ? "kit-builder__swatch" : "kit-builder__pill";
        // Sold out everywhere: disabled. Not in the current picks: crossed out
        // but clickable (selectValue moves the other picks).
        if (!valueInStock(item, opt.name, val)) {
          btn.disabled = true;
          btn.classList.add("is-soldout");
          btn.title = val + " – sold out";
        } else if (!valueIsAvailable(item, opt.name, val, sel)) {
          btn.classList.add("is-unmatched");
          btn.title = val + " – not available in " + otherPicks(item, sel, opt.name);
        }
        if (btn.title) btn.setAttribute("aria-label", btn.title);
        if (current === val) btn.classList.add("is-selected");
        var imgUrl = isColor ? optionImage(item, opt.name, val) : "";
        if (isColor && imgUrl) {
          var im = document.createElement("img");
          im.src = imgUrl;
          im.alt = val;
          btn.appendChild(im);
        } else {
          btn.textContent = val;
        }
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          if (btn.disabled) return;
          selectValue(item, sel, opt.name, val);
          self.syncAll();
          self.renderPanel(index);
        });
        box.appendChild(btn);
      });
      wrap.appendChild(box);
      mount.appendChild(wrap);
    });
  };

  KitSteps.prototype.syncAll = function () {
    var self = this;
    var totalSale = 0;
    var totalCmp = 0;
    var configured = 0;
    var soldOut = [];
    this.steps.forEach(function (step, index) {
      var item = self.item(index);
      var card = self.cardForIndex(index);
      if (!item || !card) return;
      var stepSoldOut = !(step.choices || []).some(function (choice) {
        return (choice.variants || []).some(function (v) { return v.available; });
      });
      if (stepSoldOut) soldOut.push(step.title || item.title);
      card.classList.toggle("is-soldout", stepSoldOut);
      var variant = self.currentVariant(index);
      var prices = linePrices(variant || item, self.stepDiscount(index));
      totalSale += prices.sale;
      totalCmp += prices.cmp;
      var ready = self.isConfigured(index) && variant && variant.available;
      card.classList.toggle("is-configured", !!ready);
      card.classList.toggle("is-unavailable", !!(variant && !variant.available));
      if (ready) configured += 1;
    });
    showPrice(qs(this.root, "[data-kit-total-sale]"), qs(this.root, "[data-kit-total-compare]"), qs(this.root, "[data-kit-total-pct]"), totalSale, totalCmp, this.moneyFormat);
    // Banner shows whenever the total shows a saving: kit discounts plus items on sale by themselves
    var packageSaving = totalCmp - totalSale;
    var badge = qs(this.root, "[data-kit-total-badge]");
    if (badge) {
      // visibility, not display: the banner's row keeps its height either way
      badge.classList.toggle("is-hidden", packageSaving <= 0);
      badge.textContent = "Package save " + formatMoney(packageSaving, this.moneyFormat);
    }
    var cta = qs(this.root, "[data-kit-cta]");
    var n = this.steps.length;
    var allReady = configured === n && n > 0 && !soldOut.length;
    if (cta) {
      cta.disabled = !allReady;
      cta.classList.toggle("is-soldout", soldOut.length > 0);
      var label = qs(cta, "[data-kit-cta-label]");
      var prog = qs(cta, "[data-kit-cta-progress]");
      // A step with nothing in stock can't be fixed by choosing options, so say so
      if (soldOut.length) {
        if (label) label.textContent = "Out of stock";
        if (prog) prog.textContent = soldOut.length === 1 ? soldOut[0] + " is sold out" : soldOut.length + " items are sold out";
      } else {
        if (label) label.textContent = allReady ? (this.data.addLabel || "Add to cart") : (this.data.selectLabel || "Select all items");
        if (prog) prog.textContent = allReady ? "" : (configured + "/" + n);
      }
    }
    this.renderShopPay(allReady);
  };

  // Shop Pay for the whole kit, e.g. variants="4501:1,4502:1".
  // Rebuilt on each change because the component reads its variants once.
  KitSteps.prototype.renderShopPay = function (allReady) {
    var mount = qs(this.root, "[data-kit-shop-pay]");
    if (!mount) return;

    var self = this;
    var variants = allReady ? this.steps.map(function (step, index) {
      return self.currentVariant(index).id + ":1";
    }).join(",") : "";

    if (!variants) {
      mount.hidden = true;
      mount.innerHTML = "";
      this.shopPayVariants = "";
      return;
    }

    mount.hidden = false;
    if (variants === this.shopPayVariants) return;

    this.shopPayVariants = variants;
    var button = document.createElement("shop-pay-button");
    button.setAttribute("store-url", this.data.storeUrl);
    button.setAttribute("variants", variants);

    // Drop any replacement still loading from an earlier change
    qsa(mount, ".kit-steps__shop-pay-next").forEach(function (el) { el.remove(); });
    var current = qs(mount, "shop-pay-button");
    if (!current) {
      mount.appendChild(button);
      return;
    }

    // The new button takes a moment to draw. Load it hidden on top of the
    // current one and swap once it has a height, so the space never empties.
    button.classList.add("kit-steps__shop-pay-next");
    mount.appendChild(button);
    var swapped = false;
    var observer = null;
    function swap() {
      if (swapped || !button.isConnected) return;
      swapped = true;
      if (observer) observer.disconnect();
      if (current.isConnected) current.remove();
      button.classList.remove("kit-steps__shop-pay-next");
    }
    if (window.ResizeObserver) {
      observer = new ResizeObserver(function () {
        if (button.getBoundingClientRect().height > 0) swap();
      });
      observer.observe(button);
    }
    setTimeout(swap, 3000);
  };

  // Same _kit line properties as the kit builder; _kit_step records which step
  // the item was picked for. _kit_discount is this step's % off compare-at
  // ("0" for none) and _kit_price the kit price shown for the line, in cents.
  KitSteps.prototype.submit = function (e) {
    e.preventDefault();
    var self = this;
    this.steps.forEach(function (step, index) { self.ensureSelection(index); });
    this.syncAll();
    var items = [];
    var blocked = false;
    this.steps.forEach(function (step, index) {
      var item = self.item(index);
      var v = self.currentVariant(index);
      if (!item || !v || !v.available || !self.isConfigured(index)) {
        blocked = true;
        return;
      }
      var pct = self.stepDiscount(index);
      items.push({
        id: v.id,
        quantity: 1,
        properties: {
          _kit: self.data.parentHandle,
          _kit_item: item.handle,
          _kit_step: step.title || "",
          _kit_discount: String(pct),
          _kit_price: String(linePrices(v, pct).sale)
        }
      });
    });
    if (blocked || items.length !== this.steps.length) return;
    var cta = qs(this.root, "[data-kit-cta]");
    if (cta) cta.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart add failed");
      var code = self.data.discountCode;
      if (code) window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
      else window.location.href = "/cart";
    }).catch(function () {
      if (cta) cta.disabled = false;
      alert("Could not add this kit to the cart. Please try again.");
    });
  };

  function boot() {
    qsa(document, "[data-kit-steps]").forEach(function (el) { new KitSteps(el); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
